import React from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
} from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import tokenProvider from '@utils/auth/createTokenProvider';
import OptionsDropdown from './OptionsDropdown';
import SelectLanguage from './SelectLanguage';

// import useHeader from './useHeader';
import styles from './Header.module.less';

const { isLoggedIn } = tokenProvider;

function Header(props) {

  const {
    handlerShowMenu, isShowMenu, leftContent, hideExtras,
  } = props;
  // const { clientsOptions, clientValueSelected, onChangeClient } = useHeader();
  const username = useSelector(({ user }) => user.username);

  return (
    <div className={`${styles.page_header} primary_bg`}>
      <div className={styles.content}>
        {leftContent && leftContent}

        {handlerShowMenu && (
          <Button className={styles.button_menu} type="text" onClick={handlerShowMenu}>
            {isShowMenu ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </Button>
        )}
      </div>

      {!hideExtras && (
        <div className={styles.extra}>
          <SelectLanguage className={styles.SelectLanguage} />
          {/* <Button
            type="text"
            onClick={() => {

              const win = window.open('/faq', '_blank');
              win.focus();

            }}
          >
            <FontAwesomeIcon icon={faQuestionCircle} className={styles.icon_faq} />
          </Button> */}
          {isLoggedIn() && <OptionsDropdown username={username} />}
        </div>
      )}
    </div>
  );

}

Header.propTypes = {
  handlerShowMenu: PropTypes.func,
  isShowMenu: PropTypes.bool,
  leftContent: PropTypes.node,
  hideExtras: PropTypes.bool,
};
Header.defaultProps = {
  // handlerMenu: null,
  handlerShowMenu: null,
  isShowMenu: false,
  leftContent: null,
  hideExtras: false,
};

export default Header;
